import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { EventMapContext } from '../context/EventMapContext';
import WindowQuery from '../utils/WindowQuery';

const CheckboxFilterOptions = ({ data, type }) => {
  const updateQuery = new WindowQuery();

  const isCategory = type === 'eventCategories';
  const isArea = type === 'eventAreas';

  const {
    setDropdown,
    areas,
    categories,
    setCategories,
    setAreas,
    setCurrentPage,
  } = useContext(EventMapContext);

  const [localTypes, setLocalTypes] = useState([]);

  useEffect(() => {
    if (isCategory) setLocalTypes(categories);
    if (isArea) setLocalTypes(areas);
  }, [areas, categories, isArea, isCategory]);

  const sortedData = data.sort((a, b) => {
    if (a.title < b.title) {
      return -1;
    }
    if (a.title > b.title) {
      return 1;
    }
    return 0;
  });

  let title;
  if (isCategory) title = 'Categories';
  if (isArea) title = 'Areas';

  return (
    <div className="dropdown-sorting-container">
      <h2 className="dropdown-title">{title}</h2>
      <button
        aria-label="Close Dropdown"
        name="Close Dropdown"
        type="button"
        className="mobile-dropdown-cancel btn btn--small"
        onClick={() => {
          setDropdown(null);
          if (isCategory) {
            setLocalTypes(categories);
          }
          if (isArea) {
            setLocalTypes(areas);
          }
        }}
      >
        Close
      </button>
      <section className="dropdown-sorting-inputs checkbox-filter-container">
        {sortedData.map(item => (
          <label
            key={item.value}
            className="checkbox-label"
            htmlFor={`${item.type}-type-${item.value}`}
          >
            <input
              aria-label={`${item.value}`}
              id={`${item.type}-type-${item.value}`}
              type="checkbox"
              checked={localTypes.includes(item.slug.toLowerCase())}
              onChange={() => {
                if (localTypes.includes(item.slug.toLowerCase())) {
                  setLocalTypes(
                    localTypes.filter(
                      localArea =>
                        localArea.toLowerCase() !== item.slug.toLowerCase()
                    )
                  );
                } else {
                  setLocalTypes([...localTypes, item.slug.toLowerCase()]);
                }
              }}
            />
            <p>{item.title}</p>
          </label>
        ))}
      </section>
      <div className="dropdown-actions mobile-center">
        <button
          aria-label={`Apply ${title} Filters`}
          name={`Apply ${title} Filters`}
          type="button"
          className="btn btn--dark btn--small"
          onClick={() => {
            setCurrentPage(1);
            setDropdown(null);
            if (isCategory) {
              if (localTypes.length)
                updateQuery.add('categories', localTypes.join(','));
              else updateQuery.remove('categories');
              setCategories(localTypes);
            }
            if (isArea) {
              if (localTypes.length)
                updateQuery.add('area_in', localTypes.join(','));
              else updateQuery.remove('area_in');
              setAreas(localTypes);
            }
          }}
        >
          Apply
        </button>
        <button
          aria-label={`Clear ${title} Filters`}
          name={`Clear ${title} Filters`}
          onClick={() => {
            setLocalTypes([]);
            if (isCategory) {
              setCategories([]);
              updateQuery.remove('categories');
            }
            if (isArea) {
              setAreas([]);
              updateQuery.remove('area_in');
            }
          }}
          className="btn btn--light btn--small"
          type="button"
        >
          Clear
        </button>
      </div>
    </div>
  );
};

CheckboxFilterOptions.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  type: PropTypes.oneOf(['eventCategories', 'eventAreas']),
};

export default CheckboxFilterOptions;
